const BankStatementAnalysis = (() => {
    var currPage = 1; //Pages are 1-based not 0-based
    var numPages = 0;
    var thePDF = null;
    let bankStatementAnalysisConfig = {}, promiseResolve;
    const tabsJSON = {
        search_placeholder: '',
        submit_button_name: '',
        active_tab: 'original',
        add_new_transaction_button_name: '',
        tabs: {
            original: {
                value: 'Original',
            },
            inserted: {
                value: 'Inserted',
                active: true,
                action: {
                    flag: true,
                    value: ['edit', 'delete', "add"]
                },
            },
            updated: {
                value: 'Updated',
            },
            deleted: {
                value: 'Deleted',
                action: {
                    // flag: true,
                    // value: []
                },
            },
        },
        allTABs: {
            deleted: 'deleted',
            updated: 'updated',
            inserted: 'inserted',
            original: 'original',
        },
        updatable_tabs: ["inserted", "updated", "deleted"]
    };
    const defaultConfig = {
        dataTypes: {
            type: {
                dataType: 'select-option',
                values: ['credit', 'debit']
            }
        },
        classNames: {
            table: 'analyserTransactionsTable',
            tbody: 'analyserTransactionsTableBody',
            thead: 'analyserTransactionsTableHead',
            icons: 'analyserTransactionsIconTask',
            selectOption: 'custom-select'
        },
        table: {
            default: {
                css: {
                }
            },
            edit: {
                css: {
                    /*background: '#5cb85c',
                    color: 'white'*/
                }
            },
            add: {
                css: {}
            },
            delete: {
                css: {
                    // background: '#d9534f',
                    // color: 'white'
                }
            },
            addedIndex: 0,
            deletedIndex: 0,
            updatedIndex: 0,
        },
        actionTypes: {
            original: 'original',
            edit: 'edit',
            add: 'add',
            update: 'update',
            inserted: 'inserted',
            delete: 'delete'
        },
        deletedTransactions: [],
        addedTransactions: [],
        updatedTransactions: [],
        addNewTransactionFlag: false,
        onclick: {
            changeIcons: {
                add: ['correct_symbol', 'close'],
                default: ['edit', 'delete', "add"],
                delete: [''],
                edit: ['correct_symbol', 'close'],
            },
            trIndex: -1,
            transactionType: 'original'
        },
        original: {
            transactions: [],
            headers: [],
            ignore_headers: { id: '', created_at: '', updated_at: '' },
            action: {
                flag: true,
                value: ['edit', 'delete', 'copy']
            }
        },
        deleted: {
            transactions: [],
            headers: [],
        },
        updated: {
            transactions: [],
            headers: [],
        },
        transactionTypes: ['add', 'original', 'update', 'delete'],
        zoomIntOut: {
            div0: 7,
            XOR0: 12^7,
            div1: 5,
            XOR1: 5^12,
            toggle0: 0,
            toggle1: 0
        },
        dp: [],
        originalIndex: 0,
        insertedIndex: 1,
        deletedIndex: 2,
        updatedIndex: 3,
        modifiedIndex: 3,
        activatedTAB: 'original',
        navITEMS: ['original', 'updated', 'inserted', 'deleted'],
        expected: {
            analyser: {
                keys: ["bank_name", "locale", "name", "address", "account_number", "opening_balance",
                "closing_balance", "from_date", "to_date", "currency", "is_scanned"]
            },
            transactions: {
                keys: ["date", "description", "type", "amount", "original_calculated_balance"]
            }
        },
        classToBind: ['addNewTransactionEditTextFields', 'toggleAnalyserTransactionDiv0',
            'toggleAnalyserTransactionDiv1', 'analyserTransactionsDiv0', 'analyserTransactionsDiv1',
            'closeAnalyserModal', 'analyserModalPopup', 'deleteTransactionSuccess', 'deleteTransactionFailure',
            'deleteTransactionFailure'],
        tabCount: 5, //0: original, 1: inserted, 2: deleted, 3: updated, modifiedIndex: 4
        sharedPreference: false
    };


    const widgetPromise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
    });

    /**
     * main : getting bank-analysis pdf
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param obj object
     */
    const main = (obj) => {
        const file = obj.body.file;
        initScript.toggleLoader(true);
        Object.assign(bankStatementAnalysisConfig, obj);
        if (!!!bankStatementAnalysisConfig.document_upload_url) bankStatementAnalysisConfig.document_upload_url = bankStatementAnalysisConfig.widget_service_api;
        bankStatementAnalysisConfig.security_option = !!bankStatementAnalysisConfig.body.security ? bankStatementAnalysisConfig.body.security : {};
        bankStatementAnalysisConfig.file_obj_type = !!bankStatementAnalysisConfig.body.file_obj_type ? bankStatementAnalysisConfig.body.file_obj_type : null;

        defaultConfig.icons_src = ICONSConfig.init(obj);
        defaultConfig.dp = new Array(defaultConfig.tabCount);
        for (let i = 0; i < defaultConfig.tabCount; ++i) defaultConfig.dp[i] = [];

        if (!!bankStatementAnalysisConfig.body.request_id) {
            getAnalysisTransactions(bankStatementAnalysisConfig.body.request_id, res => {
                if (!!bankStatementAnalysisConfig.body.data) {
                    defaultConfig.sharedPreference = true;
                    renderPDF(file, bankStatementAnalysisConfig.body.data, false);
                }
                else if (res.length) renderPDF(file, res, true);
                else bankStatementAnalysisByS3(file);
            });
        }
        else bankStatementAnalysisByS3(file);
    };

    function dataURLtoFile(data_url, filename) {
        /*let arr = data_url.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});*/
    }

    const base64ToFile = (data_url, file_name) => {
        return dataURLtoFile(data_url,file_name);
    };

    /**
     * renderPDF : rendering pdf on browser
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const renderPDF = (file, response, analyserFlag) => {
        if (bankStatementAnalysisConfig.file_obj_type === 'base64') getTemplate(response, analyserFlag, file);
        else fileToBase64(file).then(base64 => {
            getTemplate(response, analyserFlag, base64);
        });
    };

    /**
     * bankStatementAnalysisByPDFUtil : returning pdf transactions response
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const bankStatementAnalysisByPDFUtil = (file, callback) => {
        const form = new FormData();
        // form.append("filekey", 'upload_file');
        form.append("upload_file", file);

        const options = initScript.methodWiseOption('POST', {
            url: bankStatementAnalysisConfig.document_upload_url + "/bank-statement-analysis",
            mimeType: "multipart/form-data",
            data: form,
            processData: false,
            contentType: false
        }, bankStatementAnalysisConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.toggleLoader(true);
            if (typeof res === 'string') res = JSON.parse(res);
            callback(res);
        });
    };

    /**
     * bankStatementAnalysisByPDF : returning pdf transactions response
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const bankStatementAnalysisByPDF = (file) => {
        bankStatementAnalysisByPDFUtil(file,pdfResponse => {
            if (pdfResponse.code >= 400) bankStatementAnalysisByS3(file);
            else renderPDF(file, pdfResponse.data, false);
        });
    };

    /**
     * bankStatementAnalysisByS3 : returning pdf transactions response
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const bankStatementAnalysisByS3 = (file) => {
        showLoader();
        defaultConfig.sharedPreference = true;
        const options = initScript.methodWiseOption('POST', {
            url: bankStatementAnalysisConfig.widget_service_api + "/s3-analyser",
            data: JSON.stringify({
                "pdf_url": [bankStatementAnalysisConfig.body.s3_url]
            }),
            processData: false,
            dataType: "json",
            headers: {
                "Content-Type": "application/json"
            }
        }, bankStatementAnalysisConfig.security_option);

        HttpRequest(options, (res) => {
            hideLoader();
            renderPDF(file, res.data, false);
        });
    };

    /**
     * fileToBase64 : file to base64
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param file File
     */
    const fileToBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    /**
     * hideLoader : hiding loader
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const hideLoader = () => {
        const ele = initScript.getHTMLElementByDelimiter("widgetLoaderWrapper");
        if (ele) ele[0].style.display = "none";
    };
    /**
     * showLoader : show loader
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const showLoader = () => {
        const ele = initScript.getHTMLElementByDelimiter("widgetLoaderWrapper");
        if (ele) ele[0].style.display = "block";
    };

    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    };

    const renderingPDF = (page) => {
        const scale = 0.92;
        const viewport = page.getViewport({scale: scale});
        /*var canvas = document.getElementById('the-canvas');
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;*/

        var canvas = document.createElement( "canvas" );
        canvas.style.display = "block";
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderTask = page.render({ canvasContext: context, viewport: viewport });
        initScript.getHTMLElementByDelimiter("pdfViewer")[0].appendChild( canvas );
        renderTask.promise.then(function () {
        });
        currPage++;
        if ( thePDF !== null && currPage <= numPages )
        {
            thePDF.getPage( currPage ).then(renderingPDF);
        }
    };

    const renderPDFUsingPDFJS = (base64, page_number = 1, total_pages = 1) => {
        if (page_number > total_pages) return;
        const pdfData = atob(base64);
        const pdfjsLib = window['pdfjs-dist/build/pdf'];
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://mozilla.github.io/pdf.js/es5/build/pdf.worker.js';
        var loadingTask = pdfjsLib.getDocument({data: pdfData});
        loadingTask.promise.then(function(pdf) {
            pdf.getPage(page_number).then(function(page) {

                thePDF = pdf;
                numPages = pdf.numPages;
                // renderingPDF(page);
                pdf.getPage( 1 ).then( renderingPDF );
            });
        }, function (reason) {
            // PDF loading error
            console.error(reason);
        });
    };

    const msieversion = () => window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);

    /**
     * getTemplate : getting bank-statement-analyser-template
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param analyserResponse object
     * @param analyserFlag boolean
     * @param fileBase64 string
     */
    const getTemplate = (analyserResponse, analyserFlag, fileBase64) => {
        const options = initScript.methodWiseOption('POST', {
            url: bankStatementAnalysisConfig.widget_service_api + '/bank-statement-analyser-template',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(tabsJSON)
        }, bankStatementAnalysisConfig.security_option);

        HttpRequest(options, res => {
            var obj = document.createElement('object');
            obj.style.width = '100%';
            obj.style.height = '100%';
            obj.class = 'pdfEmbed';
            obj.type = 'application/pdf';
            obj.data = 'data:application/pdf;base64,' + fileBase64;

            initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(bankStatementAnalysisConfig.body.class), res);
            if (msieversion()) renderPDFUsingPDFJS(fileBase64);
            else {
                const blob = b64toBlob(fileBase64, 'application/pdf');
                const blobUrl = URL.createObjectURL(blob);
                PDFObject.embed(blobUrl, ".pdfViewer");
            }
            if (analyserResponse.length) showPDFParsedDataMiddleware(analyserResponse, analyserFlag);
            initScript.getHTMLElementByDelimiter('widgetAnalyserLoader').css('display', 'none');
            initScript.getHTMLElementByDelimiter(bankStatementAnalysisConfig.body.class + " tbody")["sortable"]();
        });
    };

    /**
     * hideTargetIdentifier : hide target identifier
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const hideTargetIdentifier = () => {
        if (window.navigator.userAgent.indexOf("MSIE ").length) {
            toggleDivSize(0);
            defaultConfig.toggleAnalyserTransactionDiv0.css('display', 'none');
            defaultConfig.toggleAnalyserTransactionDiv1.css('display', 'none');
        }
    };

    /**
     * isTrValuesEmpty : checking is all values of TR tag are empty or not
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const isTrValuesEmpty = (transactionType, trIndex) => {
        const transaction = getTrJSON(transactionType, trIndex);
        const keys = Object.keys(transaction);
        for (let i = 0; i < keys.length; ++i) if(keys[i] !== 'type' && transaction[keys[i]].toString().trim().length) return false;
        return true;
    };

    /**
     * bindClassesInConfig : binding target identifier
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     */
    const bindClassesInConfig = () => {
        defaultConfig.analyserTransactionsTableHeadTr = {};
        defaultConfig.analyserTransactionsTableBody = {};
        defaultConfig.analyserTransactionsTable = {};
        for (let i = 0; i < defaultConfig.navITEMS.length; ++i) {
            defaultConfig.analyserTransactionsTableHeadTr[defaultConfig.navITEMS[i]] = initScript.getHTMLElementByDelimiter(defaultConfig.navITEMS[i] + '_' + defaultConfig.classNames.thead + 'Tr');
            defaultConfig.analyserTransactionsTableBody[defaultConfig.navITEMS[i]] = initScript.getHTMLElementByDelimiter(defaultConfig.navITEMS[i] + '_' + defaultConfig.classNames.tbody);
            defaultConfig.analyserTransactionsTable[defaultConfig.navITEMS[i]] = initScript.getHTMLElementByDelimiter(defaultConfig.navITEMS[i] + '_' + defaultConfig.classNames.table);
        }
        defaultConfig.analyserTransactionsTableDataSubmit = initScript.getHTMLElementByDelimiter(defaultConfig.classNames.table + 'DataSubmit');
        defaultConfig.analyserTransactionsTableDataSearchText = initScript.getHTMLElementByDelimiter(defaultConfig.classNames.table + 'DataSearchText');

        defaultConfig.addNewTransactionEditTextFields = initScript.getHTMLElementByDelimiter('addNewTransactionEditTextFields');

        defaultConfig.toggleAnalyserTransactionDiv0 = initScript.getHTMLElementByDelimiter('toggleAnalyserTransactionDiv0');
        defaultConfig.toggleAnalyserTransactionDiv1 = initScript.getHTMLElementByDelimiter('toggleAnalyserTransactionDiv1');

        defaultConfig.analyserTransactionsDiv0 = initScript.getHTMLElementByDelimiter('analyserTransactionsDiv0');
        defaultConfig.analyserTransactionsDiv1 = initScript.getHTMLElementByDelimiter('analyserTransactionsDiv1');
        defaultConfig.closeAnalyserModal = initScript.getHTMLElementByDelimiter('closeAnalyserModal');
        defaultConfig.analyserModalPopup = initScript.getHTMLElementByDelimiter('analyserModalPopup');
        defaultConfig.deleteTransactionSuccess = initScript.getHTMLElementByDelimiter('deleteTransactionSuccess');
        defaultConfig.deleteTransactionFailure = initScript.getHTMLElementByDelimiter('deleteTransactionFailure');
        defaultConfig.resizeSection = initScript.getHTMLElementByDelimiter('resize-section');

        hideTargetIdentifier();
        bindEventsOnClasses();
        setActivatedTAB();
    };

    /**
     * toggleDivSize : toggle div size on clicking toggle button
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param divIndex number
     */
    const toggleDivSize = (divIndex) => {
        const style = ['block', 'none'];
        defaultConfig.zoomIntOut['toggle' + divIndex] ^= 1;
        defaultConfig['analyserTransactionsDiv' + (divIndex ^ 1)].css('display', style[defaultConfig.zoomIntOut['toggle' + divIndex]]);
        defaultConfig['analyserTransactionsDiv' + divIndex].css('display', style[defaultConfig.zoomIntOut['toggle' + (divIndex ^ 1)]]);

        defaultConfig['analyserTransactionsDiv' + divIndex].removeClass('col-sm-' + defaultConfig.zoomIntOut['div' + divIndex]);
        defaultConfig.zoomIntOut['div' + divIndex] ^= defaultConfig.zoomIntOut['XOR' + divIndex];
        defaultConfig['analyserTransactionsDiv' + divIndex].addClass('col-sm-' + defaultConfig.zoomIntOut['div' + divIndex]);
    };

    /**
     * addNewTransaction : adding new transaction at top of table
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     */
    const addNewTransaction = (event = undefined) => {
        if (defaultConfig.edited_row_transaction_flag) return alert('you cannot edit add new transaction without complete edited transaction.');
        let idx = 0;
        if (!!event) idx = initScript.getHTMLElementObject(event.target.parentElement.parentElement).index() + 1;
        if (!defaultConfig.addNewTransactionFlag && initScript.duplicateEmptyRowsInTableIdentifier(defaultConfig, defaultConfig.analyserTransactionsTable[defaultConfig.activatedTAB], 0)) {
            defaultConfig.addNewTransactionFlag = true;
            let icons = '';
            for (let i = 0; i < defaultConfig.onclick.changeIcons.add.length; ++i) {
                icons += defaultConfig.icons_src[defaultConfig.onclick.changeIcons.add[i] + 'IconHTML']({
                    class: getICONClass(defaultConfig.actionTypes.add, defaultConfig.table.addedIndex, defaultConfig.onclick.changeIcons.add[i])
                });
            }
            TemplateService.insertRowInTable(defaultConfig, defaultConfig.analyserTransactionsTable[defaultConfig.activatedTAB], idx + 1, new Array(defaultConfig.expected.transactions.keys.length).concat(icons), []);
            bindEventListeners(defaultConfig.onclick.changeIcons.add, defaultConfig.table.addedIndex, defaultConfig.actionTypes.add);
            updateConfig(idx);
        } else alert('duplicate empty rows are not allowed');
    };

    /**
     * getAnalyserResponse : returning expected output
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param configArray object
     * @param response object
     */
    const getAnalyserResponse = (configArray, response) => {
        let resp = {};
        if (Array.isArray(response)) {
            resp = [];
            for (let i = 0 ; i < response.length; ++i) {
                if (!response[i]) continue;
                const data = {};
                for (let j = 0; j < configArray.length; ++j) {
                    if (!!response[i]) data[configArray[j]] = response[i][configArray[j]];
                }
                resp.push(data);
            }
        } else for (let i = 0 ; i < configArray.length; ++i) resp[configArray[i]] = response[configArray[i]];
        return resp;
    };


    /**
     * getAnalysisTransactions : saving all transaction in database text fields
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param request_id string
     * @param callback function
     */
    const getAnalysisTransactions = (request_id, callback) => {
        const options = initScript.methodWiseOption('GET', {
            url: bankStatementAnalysisConfig.widget_service_api + '/widget-analysis/model/Transaction/' + request_id
        }, bankStatementAnalysisConfig.security_option);

        HttpRequest(options, res => {
            hideLoader();
            callback(Array.isArray(res.data) ? res.data : [res.data]);
        });
    };

    /**
     * getExpectedConfigResponseBySkipping : returning expected output
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param configArray object
     * @param response object
     */
    const getExpectedConfigResponseBySkipping = (configArray, response) => {
        const resp = [];
        for (let i = 0 ; i < response.length; ++i) {
            if (!!!response[i]) continue;
            const data = {};
            for (let j = 0; j < configArray.length; ++j) data[configArray[j]] = response[i][configArray[j]];
            resp.push(data);
        }
        return resp;
    };

    /**
     * submitTransactions : saving all transaction in database text fields
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param from_analyser number
     *
     */

    const submitTransactions = (from_analyser = 0) => {
        const other_than_transactions_config = defaultConfig.expected.analyser.values;
        delete other_than_transactions_config.transactions;
        showLoader();
        /* Traversing on html because we have to maintain order of transactions*/
        for (let i = 0; i < tabsJSON.updatable_tabs.length; ++i) {
            let nodes = initScript.getHTMLElementByDelimiter(getTBodyClass(tabsJSON.allTABs[tabsJSON.updatable_tabs[i]]));
            if (!nodes.length) continue;
            nodes = nodes[0].children;
            defaultConfig.dp[defaultConfig[tabsJSON.updatable_tabs[i] + "Index"]] = [];
            for (let j = 0; j < nodes.length; ++j) {
                let node_class = nodes[j].classList;
                if (msieversion()) node_class = node_class[0];
                else node_class = node_class.value;
                let transaction_type = getTRClassToTransactionType(node_class), tr_index = getTRClassToIndex(node_class);
                const transaction = getTrJSON(transaction_type, tr_index);
                defaultConfig.dp[defaultConfig[tabsJSON.updatable_tabs[i] + "Index"]].push(transaction);
            }
        }
        let _data = convertDayWiseTransaction.init(defaultConfig, other_than_transactions_config, defaultConfig.dp[defaultConfig.insertedIndex]);
        _data = {
            other: defaultConfig.sharedPreference ? _data.other : {},
            request_id: bankStatementAnalysisConfig.body.request_id,
            transactions: _data.transactions
        };
        _data.transactions.original = defaultConfig.dp[defaultConfig.originalIndex];
        _data.transactions.updated = defaultConfig.dp[defaultConfig.updatedIndex];
        _data.transactions.deleted = defaultConfig.dp[defaultConfig.deletedIndex];
        const options = initScript.methodWiseOption('POST', {
            url: bankStatementAnalysisConfig.widget_service_api + '/widget-analysis/model/Transaction',
            headers: { "Content-Type": "application/json" },
            data: JSON.stringify(_data)
        }, bankStatementAnalysisConfig.security_option);

        HttpRequest(options, res => {
            hideLoader();
            res = responseInterceptor(res);
            const data = getAnalyserResponse(defaultConfig.expected.analyser.keys, _data.other);
            data.transactions = getAnalyserResponse(["balance"].concat(defaultConfig.expected.transactions.keys), _data.transactions.inserted);
            promiseResolve({
                "code": 201,
                "from_analyser": from_analyser,
                "resource": 'analyser',
                "status": 'success',
                "data": [data]
            });
        });
    };

    /**
     * closeModal : changing modal display
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const closeModal = () => {
        AnalyserModalPopupListeners.hideModal(defaultConfig.analyserModalPopup);
    };

    /**
     * showModal : changing modal display
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const showModal = () => {
        AnalyserModalPopupListeners.showModal(defaultConfig.analyserModalPopup);
    };

    /**
     * updateTrClassByTransactionType : updating TR tag by a target JSON
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param sourceTransactionType string
     * @param targetTransactionType string
     * @param trElement object
     */
    const updateTrClassByTransactionType = (sourceTransactionType, targetTransactionType, trElement) => {
        const children = trElement.children;
        for (let i = 0; i < children.length; ++i) {
            const tdClass = initScript.getHtmlElementClass(children[i]);
            initScript.getHTMLElementObject(children[i]).attr('class', tdClass.replace(sourceTransactionType, targetTransactionType));
        }
    };

    /**
     * deleteTransactionSuccess : deleting table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const deleteTransactionSuccess = (event) => {
        closeModal();
        const trIndex = initScript.getHTMLElementObject(defaultConfig.onclick.event.target.parentElement.parentElement).index();
        moveTransactionSourceToTarget(tabsJSON.allTABs.deleted, defaultConfig.dp[defaultConfig.insertedIndex][trIndex]);
        defaultConfig.dp[defaultConfig.insertedIndex][trIndex].event = "deleted";
    };

    const deleteChild = (event) => {
        let child = event.lastElementChild;
        while (child) {
            event.removeChild(child);
            child = event.lastElementChild;
        }
    };

    /**
     * removeIconsFromTR : removing icons from selected tr
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param trElement string
     * @param flag
     */
    const removeIconsFromTR = (trElement, flag = false) => {
        deleteChild(trElement);
        // const trElementChildren = trElement.children;
        // trElementChildren[trElementChildren.length - 1].removeChild(trElementChildren[trElementChildren.length - 1]);
        // if (flag) trElementChildren[trElementChildren.length - 1].parentNode.removeChild(trElementChildren[trElementChildren.length - 1]);
    };

     /**
     * appendTransactionOnTargetTab : appending transaction on target tab
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param targetTab string
     * @param trElement string
     */
    const appendTransactionOnTargetTab = (targetTab, trElement) => {
        const tBodyClass = getTBodyClass(tabsJSON.allTABs[targetTab]);
        if (targetTab === tabsJSON.allTABs.updated) trElement = trElement.cloneNode(true);
         /* cloning node without removing table row  */
         // const trEle = trElement.cloneNode();
         // trEle.removeChild(trEle.lastElementChild);
         /*  const classes = trElement.classList;
		   initScript.getHTMLElementByDelimiter(classes[classes.length - 1]).css({
			   "background": (targetTab === "deleted") ? "red" : "",
			   // "color": "white"
		   });*/
         removeIconsFromTR(trElement.childNodes[trElement.childNodes.length - 1], true);
         initScript.appendHTMLToATarget('.' + tBodyClass, trElement);
    };

    /**
     * moveTransactionSourceToTarget : moving transactions source to target
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param targetTab boolean
     * @param transaction boolean
     */
    const moveTransactionSourceToTarget = (targetTab, transaction = undefined) => {
        const trClass = getTRClass(defaultConfig.onclick.transactionType, defaultConfig.onclick.trIndex);
        const trElement = initScript.getHTMLElementByDelimiter(trClass)[0];
        // transaction = transaction ? transaction : getTrJSON(defaultConfig.onclick.transactionType, defaultConfig.onclick.trIndex);
        // defaultConfig.dp[defaultConfig[targetTab + 'Index']].push(transaction);
        initScript.getHTMLElementByDelimiter(getSelectClass(defaultConfig.onclick.transactionType, defaultConfig.onclick.trIndex)).prop('disabled', true);
        appendTransactionOnTargetTab(targetTab, trElement);
    };
    /**
     * updateTrClassByTransactionType : cancel delete transaction
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const deleteTransactionFailure = () => {
        closeModal();
    };

    /**
     * toggleAddNewTransactionButton : toggling editable text field
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const toggleAddNewTransactionButton = () => {
        if (defaultConfig.activatedTAB !== tabsJSON.allTABs.inserted) defaultConfig.addNewTransactionEditTextFields.css('display', 'none');
        else defaultConfig.addNewTransactionEditTextFields.css('display', 'block');
    };

    /**
     * setActivatedTAB : update active tab
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     */
    const setActivatedTAB = (event) => {
        const activeTAB = initScript.getHTMLElementByDelimiter('nav-item .active').attr('href');
        const activeTargetTAB = !!event ? initScript.getHTMLElementByDelimiter(event.target).attr('href') : undefined;
        if (!!!event && !!activeTAB) defaultConfig.activatedTAB = activeTAB.replace('#', '');
        else if(!!activeTargetTAB) {
            defaultConfig.activatedTAB = activeTargetTAB.replace('#', '');
        }
        toggleAddNewTransactionButton();
    };

    /**
     * bindEventsOnClasses : binding click, keyup etc events
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindEventsOnClasses = () => {
        defaultConfig.analyserTransactionsTableDataSubmit.on('click', function(event) {
            submitTransactions();
        });
        defaultConfig.analyserTransactionsTableDataSearchText.on('keyup', function(event) {
            SearchTextUtil.bindSearchTextField(event, defaultConfig);
        });
        defaultConfig.addNewTransactionEditTextFields.on('click', function(e) {
            addNewTransaction();
        });
        defaultConfig.toggleAnalyserTransactionDiv0.on('click', function(e) {
            toggleDivSize(0);
        });
        defaultConfig.toggleAnalyserTransactionDiv1.on('click', function(e) {
            toggleDivSize(1);
        });
        defaultConfig.closeAnalyserModal.on('click', function(e) {
            closeModal();
        });
        defaultConfig.deleteTransactionSuccess.on('click', function(e) {
            deleteTransactionSuccess(e);
        });
        defaultConfig.deleteTransactionFailure.on('click', function(e) {
            deleteTransactionFailure(defaultConfig.onclick.transactionType);
        });
        initScript.getHTMLElementByDelimiter('nav-item').on('click', function(e) {
            setActivatedTAB(e);
        });
    };

    /**
     * getTRClassToIndex : extracting trIndex by trClass
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param trClass string
     */
    const getTRClassToIndex = (trClass) => {
        const ar = trClass.split('_');
        return ar[ar.length - 1];

        // return initScript.getHTMLElementByDelimiter(trClass).index();
    };

    /**
     * getTRClassToTransactionType : extracting trIndex by trClass
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param trClass string
     */
    const getTRClassToTransactionType = (trClass) => {
        const ar = trClass.split('_');
        return ar[ar.length - 3];
    };

    /**
     * getICONClass : creating ICON TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     * @param iconType string
     */
    const getICONClass = (transactionType, trIndex, iconType) => {
        return (defaultConfig.classNames.icons + '_' + defaultConfig.actionTypes[transactionType] + '_tr_' + trIndex + '_' + iconType);
    };

    /**
     * getTRClass : creating TR TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const getTRClass = (transactionType, trIndex) => {
        return (defaultConfig.classNames.tbody + '_' + transactionType + '_tr_' + trIndex);
    };

    /**
     * getTBodyClass : creating Body TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     */
    const getTBodyClass = (transactionType) => {
        return (transactionType + '_' + defaultConfig.classNames.tbody);
    };

    /**
     * getSelectClass : creating select TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const getSelectClass = (transactionType, trIndex) => {
        return (defaultConfig.classNames.tbody + '_' + transactionType + '_select_' + trIndex);
    };

    /**
     * getSelectClass : creating select option TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     * @param optionIndex
     */
    const getSelectOptionClass = (transactionType, trIndex, optionIndex) => {
        return (defaultConfig.classNames.tbody + '_' + transactionType + '_select_' + trIndex + '_option_' + optionIndex);
    };

    /**
     * getSelectClass : creating TD TAG class by config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     * @param key string
     * @param tdIndex number
     * @param other string
     */
    const getTDClass = (transactionType, trIndex, key = '', tdIndex = -1, other = '') => {
        return getTRClass(transactionType, trIndex) + '_td' + ((tdIndex !== -1) ? ('_' + tdIndex) : '') + ((key.length > 0) ? ('_' + key) : '') + ((other.length > 0) ? ('_' + other) : '');
    };

    /**
     * getSelectClass : updating analyserResponse for expected response
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param analyserResponse object
     * @param analyserFlag boolean
     */
    const showPDFParsedDataMiddleware = (analyserResponse, analyserFlag) => {
        initScript.innerHTMLToATarget(initScript.getHTMLElementObject(".analyserModalPopup .modal-body p"), "Are you sure you want to delete the transaction?");
        if (!Array.isArray(analyserResponse) || !analyserResponse.length) return;
        analyserResponse = analyserResponse[0];
        /*for (let i = 0; !!analyserResponse.transactions && i < analyserResponse.transactions.length; ++i) {
            analyserResponse.transactions[i].date = initScript.getMonthDayYearFormatDate(analyserResponse.transactions[i].date);
        }*/
        defaultConfig.analyserResponse = analyserResponse;
        defaultConfig.expected.analyser.values = getAnalyserResponse(defaultConfig.expected.analyser.keys, analyserResponse);
        showPDFParsedData({
            original: analyserFlag ? analyserResponse.original : (!!analyserResponse.transactions ? analyserResponse.transactions : []),
            updated: analyserFlag ? analyserResponse.updated : [],
            deleted: analyserFlag ? analyserResponse.deleted : [],
            inserted: analyserFlag ? analyserResponse.inserted : [],
        }).then(res => {
            extractOriginalHeaders();
            bindTransactions();
        });
    };

    /**
     * showPDFParsedData : updating config object
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactions object
     */
    const showPDFParsedData = (transactions) => {
        return new Promise((resolve, reject) => {
            bindClassesInConfig();
            const transactionType = Object.keys(transactions);
            defaultConfig.original.transactions = transactions.original;
            for (let k = 0; k < transactionType.length; ++k) {
                for (let i = 0; i < transactions[transactionType[k]].length; ++i) {
                    defaultConfig.dp[defaultConfig[transactionType[k] + 'Index']][i] = { "index": i };
                    Object.assign(defaultConfig.dp[defaultConfig[transactionType[k] + 'Index']][i], transactions[transactionType[k]][i]);
                }
            }
            if (!defaultConfig.dp[defaultConfig[tabsJSON.allTABs.inserted + 'Index']].length) {
                for (let i = 0; i < transactions[tabsJSON.allTABs.original].length; ++i) {
                    defaultConfig.dp[defaultConfig[tabsJSON.allTABs.inserted + 'Index']][i] = { "index": i };
                    Object.assign(defaultConfig.dp[defaultConfig[tabsJSON.allTABs.inserted + 'Index']][i], transactions[tabsJSON.allTABs.original][i]);
                }
            }
            resolve({});
        });
    };

    /**
     * extractOriginalHeaders : removing redundant headers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const extractOriginalHeaders = () => {
        const tableHeaders = defaultConfig.expected.transactions.keys;
        defaultConfig.original.headers = [];
        for (let i = 0; i < tableHeaders.length; ++i) {
            if (tableHeaders[i] === 'yodleePDFGenerator.js' || defaultConfig.original.ignore_headers.hasOwnProperty(tableHeaders[i])) continue;
            defaultConfig.original.headers.push(tableHeaders[i]);
        }
    };

    /**
     * bindTransactions : appending transaction on table
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const bindTransactions = () => {
        // initScript.getHTMLElementByDelimiter("analyserTransactionsTableDataSearchText").style("display", "none");
        const tableHeaders = defaultConfig.expected.transactions.keys;
        const tabs = Object.keys(tabsJSON.tabs);
        for (let k = 0; k < tabs.length; ++k) {
            const transactionType = tabs[k];
            const transactions = defaultConfig.dp[defaultConfig[tabs[k] + 'Index']];
            defaultConfig.analyserTransactionsTableHeadTr[tabs[k]].innerHTML = '';
            for (let i = 0; i < tableHeaders.length; ++i) {
                initScript.appendHTMLToATarget(defaultConfig.analyserTransactionsTableHeadTr[transactionType], '<th>'+ initScript.keyToCamelCaseWithUpperCaseString(tableHeaders[i] === "original_calculated_balance" ? "balance" : tableHeaders[i]) +'</th>');
            }
            let icons = [];
            if (tabsJSON.tabs[tabs[k]].action && tabsJSON.tabs[tabs[k]].action.flag) {
                icons = tabsJSON.tabs[tabs[k]].action.value;
                initScript.appendHTMLToATarget(defaultConfig.analyserTransactionsTableHeadTr[transactionType], '<th>Action</th>');
            }

            for (let i = 0; i < transactions.length; ++i) {
                let html = getJsonToTr(transactions[i], transactionType, i, tabs[k], icons);
                initScript.appendHTMLToATarget(defaultConfig.analyserTransactionsTableBody[tabs[k]], html);
                const trSelectClass = getSelectClass(transactionType, i);
                initScript.getHTMLElementByDelimiter(trSelectClass).val(transactions[i]['type']);
                if (icons.length) bindEventListeners(icons, i, transactionType);
            }
        }
    };

    /**
     * disableEditable : disable editable table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType object
     * @param trIndex number
     * @param iconsHTML string
     */
    const disableEditable = (transactionType, trIndex, iconsHTML) => {
        initScript.changeHTMLOfAClass(getTDClass(transactionType, trIndex, '', -1, 'icons'), iconsHTML);
        bindEventListeners(defaultConfig.onclick.changeIcons.default, trIndex, transactionType);
        // EventListeners.toggleEditableHeaders(defaultConfig, transactionType, trIndex, false);
        unWrapTR(transactionType, trIndex);
    };

    /**
     * getTrJSON : extracting table tr to text
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType object
     * @param trIndex number
     */
    const getTrJSON = (transactionType, trIndex) => {
        const headers = defaultConfig.expected.transactions.keys;
        const transaction = {};
        for (let i = 0; i < headers.length; ++i) {
            const tdClass = getTDClass(transactionType, trIndex, headers[i], i, '');
            if (initScript.getHTMLElementByDelimiter(tdClass).length) {
                const children = initScript.getHTMLElementByDelimiter(tdClass)[0].children;
                if (children.length && children[0].tagName.toLowerCase() === 'input') transaction[headers[i]] = children[0].value;
                else if (children.length && children[0].tagName.toLowerCase() === 'select') {
                    const child = initScript.getHTMLElementByDelimiter(tdClass)[0].children[0];
                    transaction[headers[i]] = child.options[child.selectedIndex].text;
                }
                else transaction[headers[i]] = initScript.getHTMLElementByDelimiter(tdClass)[0].textContent;
            }
        }
        return transaction;
    };

    /**
     * compareUpdatedRowValuesToOriginalValues : comparing table row transaction to original transaction
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType object
     * @param trIndex number
     */
    const compareUpdatedRowValuesToOriginalValues = (transactionType, trIndex) => {
        const headers = defaultConfig.expected.transactions.keys;
        const transaction = getTrJSON(transactionType, trIndex);
        for (let i = 0; i < headers.length; ++i) {
            if (!!!defaultConfig.dp[defaultConfig[transactionType + 'Index']]) continue;
            if (DistanceBtwTwoStrings.compare(('#' + defaultConfig.dp[defaultConfig[transactionType + 'Index']][trIndex][headers[i]]).trim(), ('#' + transaction[headers[i]]).trim())) {
                return true;
            }
        }
        return false;
    };

    /**
     * getJsonToTr : converting json to tr tag as per table headers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transaction object
     * @param transactionType string
     * @param trIndex number
     * @param actionType string
     * @param icons array
     */
    const getJsonToTr = (transaction, transactionType, trIndex, actionType = defaultConfig.actionTypes.original, icons = []) => {
        let html = '';
        const headers = defaultConfig.original.headers;
        for (let j = 0; j < headers.length; ++j) {
            let tdHTML = '';
            if (!!defaultConfig.dataTypes[headers[j]] && transactionType === tabsJSON.allTABs.inserted) {
                if (defaultConfig.dataTypes[headers[j]].dataType === 'select-option') {
                    for (let k = 0; k < defaultConfig.dataTypes[headers[j]].values.length; ++k) {
                        tdHTML += initScript.bindAttrsOnHTMLTag('option', defaultConfig.dataTypes[headers[j]].values[k], {
                            class: getSelectOptionClass(transactionType, trIndex, k),
                            value: defaultConfig.dataTypes[headers[j]].values[k]
                        });
                    }
                    tdHTML = initScript.bindAttrsOnHTMLTag('select', tdHTML, {
                        class: getSelectClass(transactionType, trIndex),
                        disabled: true
                    });
                }
            } else tdHTML = transaction[headers[j]] || "";
            html += initScript.bindAttrsOnHTMLTag('td', tdHTML, {
                class: getTDClass(transactionType, trIndex, headers[j], j)
            });
        }
        if (icons && icons.length) {
            let iconsHTML = initScript.attachIcons(defaultConfig, icons, transactionType, trIndex);
            html += initScript.bindAttrsOnHTMLTag('td', iconsHTML, {
                class: getTDClass(transactionType, trIndex, '', -1, 'icons')
            });
        }
        return initScript.bindAttrsOnHTMLTag('tr', html, {
            class: getTRClass(transactionType, trIndex),
        });
    };

    /**
     * copyEventListener : copy event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const copyEventListener = (transactionType, trIndex) => {
        const iconsHTML = initScript.attachIcons(defaultConfig, defaultConfig.onclick.changeIcons.default, transactionType, trIndex);
        disableEditable(transactionType, trIndex, iconsHTML);
        if (initScript.isEmptyRow(defaultConfig, transactionType, trIndex)) EventListeners.closeTransaction(transactionType, defaultConfig, defaultConfig.activatedTAB);
        if (!compareUpdatedRowValuesToOriginalValues(transactionType, trIndex)) EventListeners.defaultStyleAtRow(transactionType, defaultConfig, trIndex);
    };

    /**
     * editEventListener : edit event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const editEventListener = (transactionType, trIndex) => {
        initScript.getHTMLElementByDelimiter(bankStatementAnalysisConfig.body.class + " tbody")["droppable"]();
        if (defaultConfig.edited_row_transaction_flag || defaultConfig.addNewTransactionFlag) return alert('you cannot edit more than 1 transactions at same time.');
        initScript.setPropertyOnTargetElement(getSelectClass(transactionType, trIndex), 'disabled', false);
        defaultConfig.current_edited_row_transaction = getTrJSON(transactionType, trIndex);
        defaultConfig.edited_row_transaction_flag = true;
        EventListeners.editTransaction(transactionType, defaultConfig, trIndex);
        bindEventListeners(defaultConfig.onclick.changeIcons.edit, trIndex, transactionType);
        // initScript.getHTMLElementByDelimiter("inserted_analyserTransactionsTableBody").removeAttr("class");
    };

    /**
     * unWrapTR : unwrap table TR
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const unWrapTR = (transactionType, trIndex) => {
        const headers = defaultConfig.expected.transactions.keys;
        for (let i = 0; i < headers.length; ++i) {
            const tdClass = getTDClass(transactionType, trIndex, headers[i], i, ''), td_element = initScript.getHTMLElementByDelimiter(tdClass)[0];
            const children = initScript.getHTMLElementByDelimiter(tdClass)[0].children, tag = children[0].tagName.toLowerCase();
            if (tag === 'input') td_element.innerHTML = children[0].value;
            else initScript.getHTMLElementByDelimiter(tdClass + " select")[0].disabled = true;
        }
    };

    /**
     * setTableRowText : set json on table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transaction object
     * @param transactionType string
     * @param trIndex number
     */
    const setTableRowText = (transaction, transactionType, trIndex) => {
        const headers = defaultConfig.original.headers;
        for (let i = 0; !!transaction && i < headers.length; ++i) {
            const tdClass = getTDClass(transactionType, trIndex, headers[i], i);
            if (headers[i] === "type") initScript.getHTMLElementByDelimiter(tdClass + " option[value=" + transaction[headers[i]] + "]").prop("selected", true);
            else initScript.getHTMLElementByDelimiter(tdClass).html(transaction[headers[i]]);
        }
        defaultConfig.edited_row_transaction_flag = false;
    };

    /**
     * closeEventListener : close event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const closeEventListener = (transactionType, trIndex) => {
        if (defaultConfig.addNewTransactionFlag) {
            defaultConfig.addNewTransactionFlag = false;
            initScript.getHTMLElementByDelimiter(getTRClass(transactionType, trIndex)).remove();
            return;
        }
        initScript.setPropertyOnTargetElement(getSelectClass(transactionType, trIndex), 'disabled', true);
        // unWrapTR(transactionType, trIndex);
        const iconsHTML = initScript.attachIcons(defaultConfig, defaultConfig.onclick.changeIcons.default, transactionType, trIndex);
        disableEditable(transactionType, trIndex, iconsHTML);
        if (initScript.isEmptyRow(defaultConfig, transactionType, trIndex)) EventListeners.closeTransaction(transactionType, defaultConfig, defaultConfig.activatedTAB);
        if (!compareUpdatedRowValuesToOriginalValues(transactionType, trIndex)) EventListeners.defaultStyleAtRow(transactionType, defaultConfig, trIndex);
        setTableRowText(defaultConfig.current_edited_row_transaction, transactionType, trIndex);
    };

    /**
     * correctSymbolEventListener : correct symbol event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const correctSymbolEventListener = (transactionType, trIndex) => {
        initScript.setPropertyOnTargetElement(getSelectClass(transactionType, trIndex), 'disabled', true);
        const iconsHTML = initScript.attachIcons(defaultConfig, defaultConfig.onclick.changeIcons.default, transactionType, trIndex);
        const transaction = getTrJSON(transactionType, trIndex);
        if (transaction === null) alert("missing or invalid date format");
        else if(isTrValuesEmpty(transactionType, trIndex)) {
            alert("Empty Transaction is not allowed!!!");
            // removeTr(transactionType, trIndex);
        }
        else {
            // unWrapTR(transactionType, trIndex);
            if(!!defaultConfig.addNewTransactionFlag) {
                trIndex = initScript.getHTMLElementObject(defaultConfig.onclick.event.currentTarget.parentElement.parentElement).index();
                EventListeners.addTransaction(defaultConfig.actionTypes.add, defaultConfig, defaultConfig.table.addedIndex, iconsHTML);
                bindEventListeners(defaultConfig.onclick.changeIcons.default, defaultConfig.table.addedIndex, defaultConfig.actionTypes.add);
                defaultConfig.dp[defaultConfig.insertedIndex].splice(trIndex, 0, transaction);
                defaultConfig.table.addedIndex++;
                defaultConfig.addNewTransactionFlag = false;
                return;
            }
            disableEditable(transactionType, trIndex, iconsHTML);
            if (!compareUpdatedRowValuesToOriginalValues(transactionType, trIndex)) EventListeners.defaultStyleAtRow(transactionType, defaultConfig, trIndex);
            else {
                const insertedTransaction = {};
                Object.assign(insertedTransaction, transaction);
                if (!!defaultConfig.dp[defaultConfig.insertedIndex][trIndex].id) Object.assign(insertedTransaction, { id : defaultConfig.dp[defaultConfig.insertedIndex][trIndex].id });
                moveTransactionSourceToTarget(tabsJSON.allTABs.updated, transaction);
                defaultConfig.dp[defaultConfig.insertedIndex][trIndex] = insertedTransaction;
                defaultConfig.dp[defaultConfig.insertedIndex][trIndex].event = "updated";
            }
            defaultConfig.edited_row_transaction_flag = false;
        }
    };

    /**
     * updateEventListener : update event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const updateEventListener = (transactionType, trIndex) => {
        EventListeners.updateTransaction(transactionType, defaultConfig, trIndex);
    };

    /**
     * deleteEventListener : delete event listener
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param trIndex number
     */
    const deleteEventListener = (transactionType, trIndex) => {
        if (defaultConfig.edited_row_transaction_flag) alert('your at least one transaction pending for update.');
        else showModal();
    };

    /**
     * bindEventListeners : binding event listeners
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param icons array
     * @param trIndex number
     * @param transactionType string
     */
    const bindEventListeners = (icons, trIndex, transactionType) => {
        for (let j = 0; j < icons.length; ++j) {
            initScript.getHTMLElementByDelimiter(getICONClass(transactionType, trIndex, icons[j])).click(function(e) {
                defaultConfig.onclick.transactionType = getTRClassToTransactionType(initScript.getHtmlElementClass(e.target.parentElement.parentElement));
                defaultConfig.onclick.event = e;
                defaultConfig.onclick.trIndex = getTRClassToIndex(initScript.getHtmlElementClass(e.target.parentElement.parentElement));
                switch (icons[j]) {
                    case 'edit' :
                        editEventListener(transactionType, trIndex);
                        break;
                    case 'add' :
                        addNewTransaction(e);
                        break;
                    case 'close' :
                        closeEventListener(transactionType, trIndex);
                        break;
                    case 'correct_symbol' :
                        correctSymbolEventListener(transactionType, trIndex);
                        break;
                    case 'update' :
                        updateEventListener(transactionType, trIndex);
                        break;
                    case 'delete' :
                        deleteEventListener(transactionType, trIndex);
                        break;
                    case 'copy' :
                        copyEventListener(transactionType, trIndex);
                        break;
                    default:
                        break;
                }
            });
        }
    };

    /**
     * updateConfig : updating table tr config
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */
    const updateConfig = (idx) => {
        const firstRowElement = initScript.getHTMLElementByDelimiter(defaultConfig.activatedTAB + '_' + defaultConfig.classNames.tbody);
        const firstRowElementChildren = firstRowElement.children();
        const trClass = getTRClass(defaultConfig.actionTypes.add, defaultConfig.table.addedIndex);
        initScript.getHTMLElementByDelimiter(firstRowElementChildren[idx], '').attr('class', trClass);
        const tdChildren = initScript.getHTMLElementByDelimiter(firstRowElementChildren[idx], '').children();
        const headers = defaultConfig.expected.transactions.keys;
        for (let i = 0; i < headers.length; ++i) {
            const td_class = getTDClass(defaultConfig.actionTypes.add, defaultConfig.table.addedIndex, headers[i], i);
            if (headers[i] !== "type") {
                initScript.getHTMLElementByDelimiter(tdChildren[i], '')[0].click(function() {
                    $(this).focus();
                });
            }
            initScript.getHTMLElementByDelimiter(tdChildren[i], '').attr('class', td_class);
            initScript.getHTMLElementByDelimiter(tdChildren[i], '').attr('style', initScript.getStyleString(defaultConfig.table.add.css));
        }
        initScript.getHTMLElementByDelimiter(tdChildren[headers.length], '').attr('class', getTDClass(defaultConfig.actionTypes.add, defaultConfig.table.addedIndex, '', -1, 'icons'));
    };
    return {
        main,
        bindEventListeners,
        getTDClass,
        getTRClass,
        getICONClass,
        widgetPromise
    };
})();
